import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Icon} from 'semantic-ui-react';
import moment from 'moment';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {printDateFormat} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import VerifyInvoiceSelected from './table';
import './invoices-verification.scss';

class VerifyPendingItemsInvoiceToBin extends Component {
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.BinningChecking, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.verifyInvoice(this.props.invoice);
  }

  onCancelClick() {
    this.props.push(`/binning/chequeo/${this.props.invoice}`);
  }

  render() {
    const {invoice, loading, verifiedInvoicesList, totalItems} = this.props;
    const currentDate = moment();
    const currentDateFormatted = currentDate.format(printDateFormat);

    return (
      <div className='binning-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)}/>
              <h2>Verificar importación {'>'} {invoice}</h2>
              <div className='title-bar-actions'>
                {currentDateFormatted.toUpperCase()}
              </div>
            </div>
          </div>
        </Card>

        <VerifyInvoiceSelected loading={loading} invoice={invoice} invoicesList={verifiedInvoicesList}
          totalItems={totalItems} />
        
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {invoice} = ownProps.params;
  return {
    invoice,
    'push': ownProps.history.push,
    'loading': state.verifyInvoice.loading,
    'verifiedInvoicesList': state.verifyInvoice.verifiedInvoicesListByPage,
    'totalItems': state.verifyInvoice.verifiedInvoicesList.length || 0,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  verifyInvoice,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  verifyInvoice,
})(VerifyPendingItemsInvoiceToBin));
